module.exports = __webpack_public_path__ + "static/media/familia_1.0c310693.webp";